// import { useEffect, useState } from "react";
// import {
//   Select,
//   SelectContent,
//   SelectItem,
//   SelectTrigger,
//   SelectValue,
// } from "@/components/ui/select";

// const MONTH_NAMES = [
//   "January",
//   "February",
//   "March",
//   "April",
//   "May",
//   "June",
//   "July",
//   "August",
//   "September",
//   "October",
//   "November",
//   "December",
// ];

// const MonthYearSelector = ({ onChange }) => {
//   const today = new Date();
//   const currentMonth = MONTH_NAMES[today.getMonth()];
//   const currentYear = today.getFullYear();

//   const [date, setDate] = useState({ month: currentMonth, year: currentYear });

//   useEffect(() => {
//     if (onChange && typeof onChange === "function") {
//       const monthIndex = MONTH_NAMES.indexOf(date.month);
//       const monthNumber = String(monthIndex + 1).padStart(2, "0");
//       const formatted = `${date.year}-${monthNumber}`;
//       onChange(formatted);
//     }
//   }, [date, onChange]);

//   return (
//     <div className="flex gap-4 items-end">
//       <div className="flex flex-col">
//         <label className="mb-1 text-sm text-gray-300">Month</label>
//         <Select
//           value={date.month}
//           onValueChange={(m) => setDate((prev) => ({ ...prev, month: m }))}
//         >
//           <SelectTrigger className="w-[140px]">
//             <SelectValue placeholder="Select Month" />
//           </SelectTrigger>
//           <SelectContent>
//             {MONTH_NAMES.map((m) => (
//               <SelectItem key={m} value={m}>
//                 {m}
//               </SelectItem>
//             ))}
//           </SelectContent>
//         </Select>
//       </div>

//       {/* Year Selector */}
//       <div className="flex flex-col">
//         <label className="mb-1 text-sm text-gray-300">Year</label>
//         <Select
//           value={String(date.year)}
//           onValueChange={(y) =>
//             setDate((prev) => ({ ...prev, year: Number(y) }))
//           }
//         >
//           <SelectTrigger className="w-[120px]">
//             <SelectValue placeholder="Select Year" />
//           </SelectTrigger>
//           <SelectContent>
//             {[2023, 2024, 2025, 2026, 2027, 2028, 2029, 2030].map((y) => (
//               <SelectItem key={y} value={String(y)}>
//                 {y}
//               </SelectItem>
//             ))}
//           </SelectContent>
//         </Select>
//       </div>
//     </div>
//   );
// };

// export default MonthYearSelector;

import { useEffect, useState } from "react";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

const MONTH_NAMES = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

const MonthYearSelector = ({ onChange, defaultValue = null }) => {
  const [date, setDate] = useState(() => {
    if (defaultValue) {
      const [year, monthNum] = defaultValue.split("-");
      return {
        month: MONTH_NAMES[Number(monthNum) - 1],
        year: Number(year),
      };
    }
    const today = new Date();
    return {
      month: MONTH_NAMES[today.getMonth()],
      year: today.getFullYear(),
    };
  });

  const [initialized, setInitialized] = useState(false);

  useEffect(() => {
    if (!initialized) {
      setInitialized(true);
      return;
    }
    const monthIndex = MONTH_NAMES.indexOf(date.month);
    const monthNumber = String(monthIndex + 1).padStart(2, "0");
    const formatted = `${date.year}-${monthNumber}`;
    onChange?.(formatted);
  }, [date]);

  useEffect(() => {
    if (defaultValue) {
      const [year, monthNum] = defaultValue.split("-");
      setDate({
        month: MONTH_NAMES[Number(monthNum) - 1],
        year: Number(year),
      });
    }
  }, [defaultValue]);

  return (
    <div className="flex gap-4 items-end">
      <div className="flex flex-col">
        <label className="mb-1 text-sm text-gray-300">Month</label>
        <Select
          value={date.month}
          onValueChange={(m) => setDate((prev) => ({ ...prev, month: m }))}
        >
          <SelectTrigger className="w-[140px]">
            <SelectValue placeholder="Select Month" />
          </SelectTrigger>
          <SelectContent>
            {MONTH_NAMES.map((m) => (
              <SelectItem key={m} value={m}>
                {m}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>


      <div className="flex flex-col">
        <label className="mb-1 text-sm text-gray-300">Year</label>
        <Select
          value={String(date.year)}
          onValueChange={(y) =>
            setDate((prev) => ({ ...prev, year: Number(y) }))
          }
        >
          <SelectTrigger className="w-[120px]">
            <SelectValue placeholder="Select Year" />
          </SelectTrigger>
          <SelectContent>
            {[2023, 2024, 2025, 2026, 2027, 2028, 2029, 2030].map((y) => (
              <SelectItem key={y} value={String(y)}>
                {y}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
    </div>
  );
};

export default MonthYearSelector;
